import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useToasts } from "react-toast-notifications";
import { Box, Text, VStack } from "native-base";
import Modal from "../modal";
import { useDisclose } from "../../hooks/useDisclose";
import colors from "../../constants/colors";
import { isInIframe } from "../../utils";

const defaultInterval = 3000;

function getInterval(message = "") {
  const interval = Math.ceil(message.split(" ").length / 4) * 1000;
  if (interval > defaultInterval) {
    return interval;
  }
  return defaultInterval;
}

function Toast(props) {
  const { status } = props;
  const { addToast } = useToasts();
  const { isOpen, onClose, onOpen } = useDisclose();
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (status.errorMessage) {
      setMessage(status.errorMessage);
      addToast(status.errorMessage, {
        appearance: "error",
      });
      status.updateErrorMessage("");
    }
  }, [addToast, status, status.errorMessage, status.updateErrorMessage]);

  useEffect(() => {
    if (status.successMessage) {
      setMessage(status.successMessage);
      addToast(status.successMessage, {
        appearance: "success",
      });
      status.updateSuccessMessage("");
    }
  }, [addToast, status, status.successMessage, status.updateSuccessMessage]);

  useEffect(() => {
    if (status.infoMessage) {
      setMessage(status.infoMessage);
      addToast(status.infoMessage, {
        appearance: "info",
      });
      status.updateInfoMessage("");
    }
  }, [addToast, status, status.infoMessage, status.updateInfoMessage]);

  useEffect(() => {
    if (status.warningMessage) {
      setMessage(status.warningMessage);
      addToast(status.warningMessage, {
        appearance: "warning",
      });
      status.updateWarningMessage("");
    }
  }, [addToast, status, status.warningMessage, status.updateWarningMessage]);

  const onCloseModal = useCallback(() => {
    setMessage("");
    onClose();
  }, [onClose]);

  useEffect(() => {
    let timeout = null;
    if (message) {
      onOpen();
      timeout = setTimeout(onCloseModal, getInterval(message));
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [message, onCloseModal, onOpen]);

  if (isInIframe()) {
    return (
      <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
        <VStack padding={5} space={3}>
          <Text>{message}</Text>
          <button onClick={onCloseModal}>
            <Box
              backgroundColor={colors.primary}
              paddingY={2}
              borderRadius="full">
              <Text color={colors.white}>Cerrar</Text>
            </Box>
          </button>
        </VStack>
      </Modal>
    );
  }
  return null;
}

Toast.propTypes = {
  status: PropTypes.object.isRequired,
};

export default React.memo(Toast);
